import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { generatePassword } from "../utils/password";
import { PasswordBox } from "./PasswordBox";

const btnSx = {
  borderRadius: "20px",
  textTransform: "none",
  fontWeight: 500,
  fontSize: 13,
};

const sxTextField = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: 13,
  },
  "& .MuiInputLabel-root": {
    fontSize: 13,
  },
};

// clickAdd(body, done) — the parent owns the API call and reports back through
// done(ok, message) so this dialog can show the password after a successful add.
const AddUser = ({ open, onClose, clickAdd }) => {
  const [username, set_username] = useState("");
  const [password, set_password] = useState("");
  const [added, set_added] = useState(false);
  const [error_msg, set_error_msg] = useState("");

  // Reset on open rather than on close, so nothing flickers while it animates
  // shut and every session starts with a fresh password.
  useEffect(() => {
    if (open) {
      set_username("");
      set_password(generatePassword());
      set_added(false);
      set_error_msg("");
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: "12px" } }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          fontSize: 17,
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "#F5F7FA",
          py: 1.5,
          px: 3,
        }}
      >
        Add User
      </DialogTitle>
      <DialogContent sx={{ pt: "20px !important" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {added ? (
            <>
              <Typography sx={{ fontSize: 13, color: "#333" }}>
                Đã tạo user <b>{username}</b> với role USER. Copy password và gửi
                cho user — đóng dialog là không xem lại được nữa.
              </Typography>
              <PasswordBox value={password} />
            </>
          ) : (
            <>
              <Typography sx={{ fontSize: 12, color: "#888" }}>
                User mới luôn được tạo với role USER — đổi role bằng cách click
                vào user trong bảng sau khi tạo.
              </Typography>

              <TextField
                sx={sxTextField}
                size="small"
                id="username"
                label="Username"
                variant="outlined"
                value={username}
                onChange={(e) => set_username(e.target.value)}
              />

              <Box>
                <Typography sx={{ fontSize: 12, color: "#888", mb: 0.5 }}>
                  Password tự sinh
                </Typography>
                <PasswordBox
                  value={password}
                  onRegenerate={() => set_password(generatePassword())}
                />
              </Box>

              {error_msg !== "" && (
                <Typography sx={{ fontSize: 13, color: "#D32F2F" }}>
                  {error_msg}
                </Typography>
              )}
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {added ? (
          <Button
            size="small"
            variant="contained"
            disableElevation
            sx={btnSx}
            onClick={onClose}
          >
            Xong
          </Button>
        ) : (
          <>
            <Button size="small" sx={btnSx} onClick={onClose}>
              Cancel
            </Button>
            <Button
              size="small"
              disabled={username === "" || password === ""}
              variant="contained"
              disableElevation
              sx={btnSx}
              onClick={() =>
                clickAdd({ username: username, password: password }, (ok, msg) =>
                  ok ? set_added(true) : set_error_msg(msg)
                )
              }
            >
              Add User
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export { AddUser };
